/* src/app/modules/shared/components/header-column/header-column-quantity-in-stock/header-column-quantity-in-stock.component.scss */
/*# sourceMappingURL=header-column-quantity-in-stock.component.css.map */
